// src/circle.tsx
import { chakra } from "@chakra-ui/system";
import { jsx } from "react/jsx-runtime";
var Circle = (props) => /* @__PURE__ */ jsx(chakra.circle, { cx: 50, cy: 50, r: 42, fill: "transparent", ...props });
Circle.displayName = "Circle";

export {
  Circle
};
